import React, { useState } from 'react';

export const useLoadingState = (initialLoadingState = true) => {
    const [isLoading, setIsLoading] = useState(initialLoadingState);
    const [error, setError] = useState(null);
    
    const LoadingComponent = () => isLoading ? 
        <div className="p-6 text-gray-600">Loading...</div> : null;
        
    const ErrorComponent = () => error ? 
        <div className="p-6 text-red-600">Error: {error}</div> : null;
    
    return {
        isLoading,
        setIsLoading,
        error,
        setError,
        LoadingComponent,
        ErrorComponent
    };
}; 